import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';
import { useRouter } from 'next/router';

/**
 * Gates the provider Calendar page (`/calendar`) and its sidebar entry.
 *
 * Priority (highest to lowest):
 * 1. URL override `?provider-calendar=true|false` — always wins (dev/QA escape hatch).
 * 2. GrowthBook `provider-calendar` flag. Dark by default until the calendar
 *    feature set is complete.
 */
export const useProviderCalendarEnabled = (): boolean => {
  const router = useRouter();
  const growthBookEnabled = useFeatureIsOn(
    GROWTHBOOK_FEATURE_FLAGS.PROVIDER_CALENDAR,
  );

  const override = router.query['provider-calendar'];
  if (override === 'true') return true;
  if (override === 'false') return false;

  return growthBookEnabled;
};
